import styled from "@emotion/styled";
import { Flex } from "@otrium/core";
import BaseButton from "src/atoms/Button/BaseButton";
import { Heading } from "@otrium/atoms";

export const DialogWrapper = styled.div<{
  variant: "banner" | "settings";
}>`
  position: fixed;
  bottom: 0;
  z-index: ${({ theme }) => theme.zIndex.modal};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    display: flex;
    place-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
  }
`;

export const Dialog = styled.div<{
  height?: string;
}>`
  background-color: ${({ theme }) => theme.colors.tone.white};
  border-radius: inherit;
  background-color: ${({ theme }) => theme.colors.tone.white};
  box-shadow: 0 1px 16px ${({ theme }) => theme.effects.overlay.black_50};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  transition: height 0.6s ease-in-out;
  height: ${({ height }) => (height ? height : "auto")};

  div {
    background-color: ${({ theme }) => theme.colors.tone.white};
    border-radius: inherit;
  }

  fade-enter {
    opacity: 0;
  }

  fade-enter-active {
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
  }

  fade-exit {
    opacity: 1;
  }

  fade-exit-active {
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    width: 480px;
    box-shadow: ${({ theme }) =>
      `0 1px 16px ${theme.effects.overlay.black_50}`};
    border-radius: 8px;
  }
`;

export const DialogHeader = styled(Flex)<{ variant: "banner" | "settings" }>`
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: ${({ theme, variant }) =>
    variant === "banner" ? theme.space.space16 : 0};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    width: 100%;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 100%;
  }
`;

export const DialogBody = styled.div<{ variant: "banner" | "settings" }>`
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  width: 100%;
  margin-bottom: ${({ theme }) => theme.space.space16};
  color: ${({ theme }) => theme.colors.tone.anthraciteDark};
  max-height: ${({ variant }) =>
    variant === "banner" ? "none" : "calc(100vh - 280px)"};
  overflow: ${({ variant }) => (variant === "banner" ? "visible" : "scroll")};
  letter-spacing: 0px;
  scrollbar-width: none;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    max-height: none;
  }

  @media only screen and (max-width: 768px) {
    max-height: ${({ variant }) =>
      variant === "banner" ? "none" : "calc(100vh - 370px)"};
  }

  &::-webkit-scrollbar {
    display: none;
  }

  > button {
    display: inline;
    text-decoration-thickness: 1px;

    &:hover {
      text-decoration-thickness: 1px;
    }
  }
`;

export const DialogFooter = styled(Flex)<{ variant: "banner" | "settings" }>`
  margin-top: ${({ theme }) => theme.space.space16};
  flex-direction: column;
  gap: ${({ theme }) => theme.space.space16};
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 0;
`;

export const DialogTitle = styled(Heading)`
  font-family: "PlusJakartaSans";
  font-size: ${({ theme }) => theme.fontSizes.fontSize18};
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0px;
  line-height: 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    font-size: ${({ theme }) => theme.fontSizes.fontSize20};
  }
`;

export const DialogDescription = styled.div`
  width: 100%;
  margin-top: ${({ theme }) => theme.space.space16};
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  color: ${({ theme }) => theme.colors.tone.anthraciteDark};
  letter-spacing: 0px;

  p,
  a,
  span {
    color: ${({ theme }) => theme.colors.tone.anthraciteDark};
    display: inline;
  }

  a,
  a:hover {
    text-decoration-thickness: 1px;
  }
`;

export const ConsentList = styled.ul`
  list-style: none;
`;

export const ConsentItem = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.colors.tone.marble};

  &:last-of-type {
    border-bottom: none;
  }
`;

export const ConsentItemHeader = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  & > label {
    flex-shrink: 0;
  }
`;

export const ConsentItemTitle = styled(BaseButton)<{ expanded: boolean }>`
  display: flex;
  align-items: center;
  flex-grow: 1;
  text-align: left;
  padding-inline: 0;
  padding-block: 16px;
  background: none;
  border: none;
  outline: none;
  color: ${({ theme }) => theme.colors.tone.black};
  font-size: ${({ theme }) => theme.fontSizes.fontSize16};
  line-height: 24px;
  max-width: calc(100% - 28px);
  overflow: hidden;

  & > span {
    margin-left: ${({ theme }) => theme.space.space8};
  }

  & > svg {
    transition: transform 300ms ease-in;
    transform: rotate(${({ expanded }) => (expanded ? "90deg" : "0deg")});
    min-width: 8px;
  }

  & > svg g {
    stroke: ${({ theme }) => theme.colors.tone.black};
  }
`;

export const ConsentItemDescription = styled.p`
  padding-bottom: ${({ theme }) => theme.space.space16};
  word-wrap: break-word;
`;
